import {
  ILoginRequest,
  IRegisterRequest,
} from 'src/app/interfaces/request.interfces';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { appStorage } from '../utils/localStorage.utilservice';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  END_POINT = environment.API_ENDPOINT + '/auth/login';
  constructor(private http: HttpClient, private router: Router) {}

  login(data: ILoginRequest) {
    return this.http.post(this.END_POINT + '/admin', data);
  }

  register(data: IRegisterRequest) {
    return this.http.post(this.END_POINT + '/admin', data);
  }

  logout() {
    appStorage.removeToken();
    this.router.navigate(['/auth']);
  }
}
